import { Request } from "express";
import { BobRequest } from "../../model/bob-request";
import { PageRepository } from "../../repositories/page-repository";
import { BaseChainableComponent } from "../pipeline/base-chainable-component";

export class BobrequestTranslatorComponent extends BaseChainableComponent<BobRequest> {

	private portalPageRepository: PageRepository;

	constructor(portalPageRepository: PageRepository) {

		super();
		this.portalPageRepository = portalPageRepository;
	}

	public async process(request: Request) {

		const portalPage = await this.portalPageRepository.get(request.originalUrl, request.headers);

		if (!portalPage) {
			this.logger.error("Couldn't retrieve portal page " + request.originalUrl, portalPage);
			return;
		}

		const bobRequest = new BobRequest(portalPage.statusCode, portalPage.body, portalPage.headers);

		if (portalPage.statusCode >= 300 && portalPage.statusCode < 400) {
			return bobRequest;
		}

		return await this.next.process(bobRequest);
	}
}
